import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress, Alert, Button } from '@mui/material';
import { useExtensions } from '../app/ExtensionsContext';
import { useTranslation } from '../app/LanguageContext';

export default function ExtensionRoute({ extensionId, children }) {
  const { isEnabled, loading, loadError, reload } = useExtensions();
  const { translate } = useTranslation();

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
        }}
      >
        <CircularProgress aria-label={translate('common.loading')} />
      </Box>
    );
  }

  if (loadError) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          px: 2,
        }}
      >
        <Alert
          severity="warning"
          action={
            <Button color="inherit" size="small" onClick={() => reload()}>
              {translate('auth.session_retry')}
            </Button>
          }
          sx={{ maxWidth: 480 }}
        >
          {translate('extensions.load_error')}
        </Alert>
      </Box>
    );
  }

  if (!isEnabled(extensionId)) return <Navigate to="/" replace />;
  return children;
}
